export const nullIfNaN = (a: number): number | null => isNaN(a) ? null : a;
